import React, { useEffect } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Outlet,
  useLocation,
  useNavigate,
  Route,
} from 'react-router-dom';
import './App.css';
import AkakshiLanding from './components/home/Home';
import Login from './components/auth/Login';
import Logout from './components/auth/Logout';
import Signup from './components/auth/Signup';
import DashboardPages from './components/dashboard/DashboardPages';
import Layout from './components/layout/Layout';
import DataSourceMangement from './components/MasterReports/DataSourceMangement';
import UserMasterReports from './components/MasterReports/UserMasterReports';
import Common from './components/MasterReports/Common';
import { setFindUserByIdUser } from './redux-toolkit/slices/allUserSlice';
import { useAppDispatch, useAppSelector } from './redux-toolkit/hooks';
import { getLocalStorageData } from './utils/LocalStorageService';
import { useGetUserByIdMutation } from './redux-toolkit/services/allUserService';
import { getAuthData } from './redux-toolkit/slices/authSlice';
import Master from './components/MasterReports/Master';
import FOInvestmentData from './components/MasterReports/FOInvestmentData';
import FOInvestment from './components/MasterReports/FOInvestment';
import Document from './components/MasterReports/Document';
import Opportunity from './components/MasterReports/Opportunity';
import Events from './components/MasterReports/Events';

function App() {

  const localUserObj = getLocalStorageData("localUser");
  const location = useLocation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [findUserById, findUserByIdResponse] = useGetUserByIdMutation();

  const authUserData = useAppSelector(getAuthData);

  useEffect(() => {
    if (localUserObj) {
      findUserById({
        id: localUserObj.id,
        token: localUserObj.token
      });
    }
  }, [authUserData]);

  useEffect(() => {
    if (findUserByIdResponse.isSuccess) {
      localStorage.setItem("routeTo", "dashboard");
      dispatch(setFindUserByIdUser(findUserByIdResponse));
    }
  }, [findUserByIdResponse.isSuccess]);

  useEffect(() => {
    if (localUserObj) {
      if (findUserByIdResponse.isSuccess) {
        if (location.pathname === "/login") {
          navigate("/dashboard");

        } else {
          navigate(location.pathname);
        }
      } else if (location.pathname === "/") {
        navigate("/login");
      }
    } else {
      navigate("/login", { replace: true });
    }
  }, [findUserByIdResponse.isSuccess, authUserData]);


  return (
    <div className="App">
      <Routes>
        <Route path="/akashik" element={<AkakshiLanding />} />
        <Route path="/dashboard" element={<Layout />}>
          <Route index element={<DashboardPages />} />
          <Route path=":reportType" element={<DashboardPages />} />
        </Route>
        <Route path="/" element={<Layout />}>
          <Route path="gmis-master" element={<Outlet />}>
            <Route path=":reportType" element={<Master />} />
          </Route>
          <Route path="opportunity" element={<Outlet />}>
            <Route path=":reportType" element={<Opportunity />} />
          </Route>
          <Route path="data-source" element={<Outlet />}>
            <Route path=":reportType" element={<DataSourceMangement />} />
          </Route>
          <Route path="user-master" element={<Outlet />}>
            <Route path=":reportType" element={<UserMasterReports />} />
          </Route>
          <Route path="document" element={<Outlet />}>
            <Route path=":reportType" element={<Document />} />
          </Route>
          <Route path="fo-investment" element={<Outlet />}>
            <Route path=":reportType" element={<FOInvestment />} />
          </Route>
          <Route path="common" element={<Outlet />}>
            <Route path=":reportType" element={<Common />} />
          </Route>
          <Route path="events" element={<Outlet />}>
            <Route path=":reportType" element={<Events />} />
          </Route>
        </Route>
        <Route path="/login" element={<Login />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/signup" element={<Signup />} />
      </Routes>
    </div>
  );
}

export default App;
